import { useState, type ReactNode } from 'react'
import { Card, CardContent, CardHeader } from '../Card'
import { OverflowMenu } from '../Menu'
import { ChartCardContext, colorVar, type ChartColor } from './chartKit'

export interface ChartLegendItem {
  label: string
  color?: ChartColor | undefined
}

export interface ChartCardProps {
  title: string
  subtitle?: string | undefined
  /** Legenda delle serie, colori nell'ordine di default dei grafici se `color` manca. */
  legend?: ChartLegendItem[] | undefined
  /** Controlli accanto al menu (per esempio un ButtonGroup). */
  actions?: ReactNode | undefined
  children: ReactNode
  className?: string | undefined
  headingLevel?: 2 | 3 | 4 | undefined
}

/** Cornice di un grafico: titolo, sottotitolo, legenda e menu "Mostra come tabella" (la tabella equivalente sostituisce il grafico). */
export function ChartCard({ title, subtitle, legend, actions, children, className, headingLevel = 3 }: ChartCardProps) {
  const [showTable, setShowTable] = useState(false)
  return (
    <Card variant="outlined" className={className}>
      <CardHeader
        title={title}
        subtitle={subtitle}
        headingLevel={headingLevel}
        actions={
          <>
            {actions}
            <OverflowMenu
              aria-label={`Opzioni del grafico ${title}`}
              size="sm"
              items={[{ label: showTable ? 'Mostra come grafico' : 'Mostra come tabella', icon: showTable ? 'bar_chart' : 'table', onSelect: () => setShowTable(v => !v) }]}
            />
          </>
        }
      />
      <CardContent>
        <div className="md-chart-card__body">
          {legend && legend.length > 0 ? (
            <ul className="md-chart-legend" aria-label="Legenda">
              {legend.map((l, i) => (
                <li key={l.label}><span className="md-chart__swatch" style={{ background: colorVar(l.color, i) }} aria-hidden="true" />{l.label}</li>
              ))}
            </ul>
          ) : null}
          <ChartCardContext.Provider value={{ showTable }}>{children}</ChartCardContext.Provider>
        </div>
      </CardContent>
    </Card>
  )
}
